<div
    (click)="openLink()"
    class="inline-flex wrapper"
    role="button"
    tabindex="0"
>
    <span class="underline text-primary">
        <ng-content></ng-content>
    </span>
    <mat-icon class="text-primary" svgIcon="new-tab"></mat-icon>
</div>
